import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useGetCall, usePost } from "seed/api";
import View from "components/Home.view";
import { Loading } from "seed/helpers"
import { Analytics } from "components/util/analytics";

function Home() {

	const urlParams = new URLSearchParams(window.location.search);
	const location = useLocation();
	const token = urlParams.get("token");
	const userId = urlParams.get("user_id");

	const [isAuth, setIsAuth] = useState(false);
	const [user, setUser] = useState(null)
	const [theme, setTheme] = useState(null)

	const [callTheme] = usePost("/users/get_theme", {
		onCompleted: (data) => setTheme(data)
	})

	const [callAuth] = useGetCall("/auth/user", "", {
		onCompleted: (data) => {

			sessionStorage.setItem("execution_session_id", Math.random().toString(36).substring(2, 15) +
				Math.random().toString(36).substring(2, 15));

			setIsAuth(true)
			callTheme()
			setUser(data)
			const segment = localStorage.getItem("userProfile")
			const hiddenUserId = localStorage.getItem("hiddenUserId");

			Analytics.Identify(hiddenUserId || data.user, {
				'hidden_user_id': hiddenUserId || data.user,
				'user_id': data.user,
				'segment': segment
			});
		},
		onError: () => {
			sessionStorage.clear();
			localStorage.clear();
			window.location.replace(`/login?next=${encodeURIComponent(new URL(window.location.href).pathname)}`);
		}
	})

	useEffect(() => {
		if (!user) return console.log("No user data");
		sessionStorage.setItem("show_helps", user?.account_settings?.showHelps ?? true);
		//const wasOnboardingCompleted = user?.was_onboarding_completed ?? false;
		//if (!wasOnboardingCompleted && location.pathname != "/app/onboarding") window.location.replace("/app/onboarding");
	}, [user]);

	useEffect(() => {
		if (token) { //Preload data from URL
			sessionStorage.setItem("token", token);
			sessionStorage.setItem("id", userId);
			localStorage.setItem("token", token);
			localStorage.setItem("id", userId);
		}
		if (localStorage.getItem("id") != null) { //Preload data from localStorage
			sessionStorage.setItem("token", localStorage.getItem("token"));
			sessionStorage.setItem("id", localStorage.getItem("id"));
			sessionStorage.setItem("is_developer", localStorage.getItem("is_developer"));
		}

		callAuth({ user_id: sessionStorage.getItem("id") });
	}, [token, userId]); // eslint-disable-line react-hooks/exhaustive-deps

	if (!isAuth || !theme) return <Loading />;

	return <View user={user} theme={theme} />;
}

export default Home;